import uniqid from 'uniqid';

export const USER_DETAILS_FIELD_NAMES = {
  EMAIL: 'email',
  CONFIRM_EMAIL: 'confirmEmail',
  ROLE: 'role',
  CLIENT: 'client',
} as const;

export type UserDetailsFieldName =
  (typeof USER_DETAILS_FIELD_NAMES)[keyof typeof USER_DETAILS_FIELD_NAMES];

export type UserDetailsFormFieldMode = 'CREATE_AND_EDIT_MODE' | 'CREATE_MODE';

export interface UserDetailsFormField {
  name: UserDetailsFieldName;
  label: string;
  key: string;
  mode: UserDetailsFormFieldMode;
  isSelect?: boolean;
  alwaysVisible?: boolean;
  renderComponentProps: Record<string, string>;
  disabled?: boolean;
}

export const USER_DETAILS_FORM_FIELDS: UserDetailsFormField[] = [
  {
    name: USER_DETAILS_FIELD_NAMES.EMAIL,
    label: 'Email address',
    renderComponentProps: {
      helperText:
        'Please use an email address associated with one of the following domains:',
      'data-testid': 'user-email-input',
    },
    key: uniqid(),
    mode: 'CREATE_AND_EDIT_MODE',
  },
  {
    name: USER_DETAILS_FIELD_NAMES.CONFIRM_EMAIL,
    label: 'Confirm email',
    renderComponentProps: {
      helperText: 'Please ensure the emails match',
      'data-testid': 'user-confirm-email-input',
    },
    key: uniqid(),
    mode: 'CREATE_MODE',
  },
  {
    name: USER_DETAILS_FIELD_NAMES.ROLE,
    label: 'Role',
    isSelect: true,
    key: uniqid(),
    mode: 'CREATE_AND_EDIT_MODE',
    alwaysVisible: true,
    renderComponentProps: {
      'data-testid': 'user-role-input',
    },
  },
  {
    name: USER_DETAILS_FIELD_NAMES.CLIENT,
    label: 'Client',
    isSelect: true,
    key: uniqid(),
    mode: 'CREATE_AND_EDIT_MODE',
    renderComponentProps: {
      'data-testid': 'user-client-input',
    },
  },
];
